import {MapSettingActionEnum, IMapSettingAction} from "./types"
import {AppDispatch} from "../../index";



const sett = {
  deleteToVisibleLayersAction : (payload: any): IMapSettingAction=>({type: MapSettingActionEnum.DELETE_TO_VISIBLE_LAYERS, payload}),
  pushToVisibleLayersAction : (payload: any): IMapSettingAction => ({type: MapSettingActionEnum.PUSH_TO_VISIBLE_LAYERS, payload}),

  deleteToVisibleLayers: (listLayers: any)=> (dispatch: AppDispatch) =>{
    dispatch(sett.deleteToVisibleLayersAction(listLayers))
  },
  pushToVisibleLayers: (listLayers: any)=> (dispatch: AppDispatch) =>{
    dispatch(sett.pushToVisibleLayersAction(listLayers))
  },
  setLayerSettings: (settings: any)=> (dispatch: AppDispatch) =>{
    dispatch({ type: MapSettingActionEnum.SET_LAYER_SETTINGS, payload: settings })
  }
}

export default sett;